import * as React from 'react';
import { Typography } from '@mui/material';
import { Body, SectionContainer, Title } from './section.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Section component.
 *
 * @author Ihar Kazlouski
 * @function Section
 * @category components
 * @return {FC} button component.
 */
var Section = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(SectionContainer, {
    ref: ref,
    "data-testid": "".concat(title, "-section"),
    children: [title && /*#__PURE__*/_jsx(Title, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        fontWeight: "bold",
        children: title
      })
    }), /*#__PURE__*/_jsx(Body, {
      children: children
    })]
  });
});
Section.displayName = 'Section';
export { Section };